// extracted by mini-css-extract-plugin
export default {"inputField":"components-Shared-Form-themes-BGH-RD3-input__inputField--mjFQ8"};